import script from "./fichePrestataireView.vue?vue&type=script&setup=true&lang=js"
export * from "./fichePrestataireView.vue?vue&type=script&setup=true&lang=js"

import "./fichePrestataireView.vue?vue&type=style&index=0&id=45268310&lang=scss&scoped=true"
import "./fichePrestataireView.vue?vue&type=style&index=1&id=45268310&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45268310"]])

export default __exports__